import React from 'react';

import { 
    Col,
    Card
 } from "react-bootstrap";
const EducationCard = ({data}) => {
    return ( 
        <Col lg="6">
            <div className="pb-5 text-center">
                <img className=" bg-light mb-3" src={data.universitylogo} alt="" style={{maxWidth: 300,maxHeight: 100}}/>
                <p className="lead">
                    <b>Thesis</b>: {data.thesis}
                    <br/>
                    {data.date}
                </p>
                
            </div>
        </Col>
     );
}
 
export default EducationCard;